import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/FromTreeToViewer/createModelsMap.worker.ts";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { getViewerId as _getViewerId } from "../../classifier-editor/Common";
import { getChildren, getNode } from "../../classifier-service";
import { isReferenceNode, isBimModelNotLoadedNode, isBimNode, isUserClassifierGroupWithElementsNode, isUserClassifierGroupNode, isUserClassifierGroupWithGroupsNode } from "../../classifier-service/Node";

var createModelMap = function createModelMap(props) {
  var acc = props.acc,
      next = props.next,
      nodes = props.nodes,
      checkedStore = props.checkedStore,
      getViewerId = props.getViewerId;
  var node = getNode(nodes, typeof next === 'string' ? checkedStore.checkedMap[next] : {
    id: next.id,
    type: next.type
  });
  var key = _typeof(next) === 'object' ? next.type + next.id : next;

  if (!node) {
    return acc;
  }

  var viewerDisplayModelForReferenceNode = function viewerDisplayModelForReferenceNode(node) {
    var element = getNode(nodes, node.element);

    if (!element || isBimModelNotLoadedNode(element)) {
      return acc;
    }

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, element.viewerRefs.map(function (ref) {
      return _objectSpread(_objectSpread({}, ref), {}, {
        viewerId: getViewerId(element, ref)
      });
    })));
  };

  var viewerDisplayModelForBimNode = function viewerDisplayModelForBimNode(node) {
    var viewerRefs = node.viewerRefs;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, viewerRefs.map(function (ref) {
      return _objectSpread(_objectSpread({}, ref), {}, {
        viewerId: getViewerId(node, ref)
      });
    })));
  };

  var viewerDisplayModelForUserClassifierGroupWithElementsNode = function viewerDisplayModelForUserClassifierGroupWithElementsNode(node) {
    var elements = node.children.reduce(function (res, child) {
      return _objectSpread(_objectSpread({}, res), createModelMap(_objectSpread(_objectSpread({}, props), {}, {
        next: {
          type: child.type,
          id: child.id
        }
      })));
    }, {});
    return _objectSpread(_objectSpread({}, acc), elements);
  };

  var viewerDisplayModelForUserClassifierGroupWithGroupsNode = function viewerDisplayModelForUserClassifierGroupWithGroupsNode(node) {
    var elementChildren = getChildren(nodes, node);
    var elements = elementChildren.reduce(function (acc, element) {
      return _objectSpread(_objectSpread({}, acc), viewerDisplayModelForUserClassifierGroupNode(element));
    }, {});
    return _objectSpread(_objectSpread({}, acc), elements);
  };

  var viewerDisplayModelForUserClassifierGroupNode = function viewerDisplayModelForUserClassifierGroupNode(node) {
    if (isUserClassifierGroupWithElementsNode(node)) {
      return viewerDisplayModelForUserClassifierGroupWithElementsNode(node);
    } else if (isUserClassifierGroupWithGroupsNode(node)) {
      return viewerDisplayModelForUserClassifierGroupWithGroupsNode(node);
    }

    return _objectSpread({}, acc);
  };

  if (isBimNode(node) && !isBimModelNotLoadedNode(node)) {
    return viewerDisplayModelForBimNode(node);
  } else if (isReferenceNode(node)) {
    return viewerDisplayModelForReferenceNode(node);
  } else if (isUserClassifierGroupNode(node)) {
    return viewerDisplayModelForUserClassifierGroupNode(node);
  }

  return acc;
};

var createModelsMap = function createModelsMap(_ref) {
  var nodes = _ref.nodes,
      checkedStore = _ref.checkedStore;
  return Object.keys(checkedStore.checkedMap).reduce(function (acc, next) {
    return createModelMap({
      acc: acc,
      next: next,
      nodes: nodes,
      checkedStore: checkedStore,
      getViewerId: function getViewerId(node, viewerRef) {
        return _getViewerId({
          node: node,
          viewerRef: viewerRef,
          nodes: nodes,
          getNodeFunc: getNode
        });
      }
    });
  }, {});
}; // eslint-disable-next-line no-restricted-globals


self.onmessage = function (_ref2) {
  var data = _ref2.data;
  var result = createModelsMap(data); // eslint-disable-next-line no-restricted-globals

  self.postMessage(JSON.stringify(result));
};